import * as ProviderTeam from './models/providerTeam';

import { Common } from './common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    args: {
      providerUserId?: string;
      practiceId?: string;
    } = {},
  ): Promise<ProviderTeam.ProviderTeam[]> {
    const url = this.common.constructPath(`/provider-teams`, args);
    return this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<ProviderTeam.ProviderTeam> {
    const url = this.common.constructPath(`/provider-teams/${id}`);
    return this.common.getJSON(url);
  }

  async create(
    values: ProviderTeam.CreateValues,
  ): Promise<ProviderTeam.ProviderTeam> {
    const url = this.common.constructPath(`/provider-teams`);
    return this.common.postJSON(url, values);
  }
}
